import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const currentPathSlice = createSlice({
  name: "currentPath",
  initialState: null as string | null,
  reducers: {
    setCurrentPath: (_state: string | null, action: PayloadAction<string | null>) => action.payload,
  },
});

export const { setCurrentPath } = currentPathSlice.actions;

export const currentPath = currentPathSlice.reducer;

export default currentPathSlice.reducer;
